import { DetailBaseData } from '../Models';
import { isBuildType } from './build';

export const isNavigationItemHidden: Function = (node: DetailBaseData): boolean => {
    if (node.type === 'customers') { return false };
    if (node.name === undefined || node.name === null) { return true; }
    if (node.name.toLowerCase().startsWith('mr-')) { return true; }
    if (node.type && isBuildType(node.type)) { return true; }

    return false;
}
